<template>
  <el-scrollbar>
    <el-table
      :data="tableData"
      ref="rscKeyTable"
      highlight-current-row
      height="calc(100% - 35px)"
      style="width: 100%;"
      border
      :class="['popup', 'rsc-key-table', disabled ? 'disabled' : '']"
      @current-change="rscKeyCurrentChange"
    >
      <el-table-column prop="checked" header-align="left" align="center" label="선택" width="50">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.checked" @change="onCheckChange"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column
      prop="valueName"
      label="자원키 명"
      header-align="left"
      align="center"
      >
    </el-table-column>
  </el-table>
  </el-scrollbar>
</template>

<script>
import { isEmpty } from '@/utils/basic';
import find from 'lodash/find';
import WidgetAPI from '@/api/dashboard/widget';

export default {
  name: 'WRscKeySelectTable',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    isMultiple: {
      type: Boolean,
      default: null,
    },
    selecetedData: {
      type: [Object, Array],
      default: () => {},
    },
  },
  data() {
    return {
      tableData: null,
      currentData: [],
      rscKeyInfo: [],
    };
  },
  methods: {
    initData() {
      this.tableData = [];
    },
    loadData(params) {
      // const params = this.rscKeyParams;
      const { managetypeId, objIds, rsctypeIds, rscIds, rscKeyInfo } = params;
      WidgetAPI.getObjRscKeyList(managetypeId, objIds, rsctypeIds, rscIds).then((response) => {
        this.tableData = response.data.data;
        this.$nextTick(() => {
          this.setRscKeyInfo(rscKeyInfo);
        });
      });
    },
    setRscKeyInfo(rscKeyInfo) {
      if (!isEmpty(rscKeyInfo)) {
        this.tableData.forEach((item) => {
          this.setCheckedRscKey(item, rscKeyInfo);
        });
      }
    },
    setCheckedRscKey(item, rscKeyInfo) {
      rscKeyInfo.forEach((rsc) => {
        if (rsc.rscKey === item.rscKey) {
          item.checked = true;
        }
      });
    },
    setRscKeyTableCurrentRow() {
      const rscKeyInfo = find(this.tableData, this.rscKeyInfo[0]);
      rscKeyInfo.checked = true;
      this.$refs.rscKeyTable.setCurrentRow(rscKeyInfo);
    },
    rscKeyCurrentChange(currentRow) {
      if (!isEmpty(currentRow)) {
        currentRow.checked = true;
        this.rscKeyInfo.forEach((item) => {
          if (item.rscKey === currentRow.rscKey) {
            this.rscKeyInfo.splice(this.rscKeyInfo.indexOf({ rscKey: currentRow.rscKey }), 1);
          } else {
            this.rscKeyInfo.push({
              rscKey: currentRow.rscKey,
            });
          }
        });
        this.$emit('update:selectedData', [currentRow]);
      }
    },
    getCurruntData() {
      const currentData = [];
      if (!isEmpty(this.tableData)) {
        this.tableData.forEach((item) => {
          if (item.checked) {
            currentData.push(item);
          }
        });
      }
      return currentData;
    },
    onCheckChange() {
      this.$emit('update:selectedData', this.getCurruntData());
    },
  },
};
</script>

<style lang="scss">
.rsc-key-table {
  transition: opacity .15s ease-in .05s;
  -webkit-transition: opacity .15s ease-in .05s;
  border-bottom: 1px solid #ebeef5 !important;
}
.rsc-key-table.disabled {
  opacity: 0.4;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/widgets/coord/setting/components/RscKeySelectTable.vue